"use client";

import { useDPC } from "@/app/_helpers/Events";
import React, { useEffect } from "react";

export const DepictView = ({ productId }: { productId: string | undefined }) => {
	const { data: dpc } = useDPC();
	useEffect(() => {
		if (!dpc || !productId) return;

		dpc.setProductId(productId);
	}, [dpc, productId]);
	return null;
};
